"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StackedBarChart = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var d3 = tslib_1.__importStar(require("d3"));
var isEqual_1 = tslib_1.__importDefault(require("lodash/fp/isEqual"));
var uniqueId_1 = tslib_1.__importDefault(require("lodash/fp/uniqueId"));
var chartUtils_1 = require("../../chartUtils");
var BarChartUtils_1 = require("../BarChartUtils");
var StackedBarChartUtils_1 = require("./StackedBarChartUtils");
var ChartContainer_1 = require("../../ChartContainer");
var Axis_1 = require("../../Axis");
var ChartScrollButton_1 = require("../../ChartScrollButton");
var ChartScrollCurtain_1 = require("../../ChartScrollCurtain");
var BarChartVerticalGridLine_1 = require("../BarChartVerticalGridLine");
var StackedBar_1 = require("./StackedBar");
var ChartTooltip_1 = require("../../ChartTooltip");
var StackedBarChart = (function (_super) {
    tslib_1.__extends(StackedBarChart, _super);
    function StackedBarChart(props) {
        var _this = _super.call(this, props) || this;
        _this.onDragScrollEnd = function () {
            _this.setState({ scrollCursor: 'grab' });
        };
        _this.onMouseOverBars = function (_a) {
            var _b, _c, _d;
            var group = _a.group, groupNumber = _a.groupNumber, event = _a.event, xScale = _a.xScale, xAxisType = _a.xAxisType;
            var pageY = event.pageY;
            var _e = _this.props, data = _e.data, _f = _e.chartContainerType, chartContainerType = _f === void 0 ? 'OTHER' : _f, _g = _e.tooltipXOffset, tooltipXOffset = _g === void 0 ? 0 : _g, _h = _e.tooltipYOffset, tooltipYOffset = _h === void 0 ? 0 : _h;
            var subGroups = data.subGroups, aggregateTypes = data.aggregateTypes;
            var boundingRec = (_b = _this.SVGElement) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();
            var absoluteMouseYLocation = pageY - ((_c = boundingRec === null || boundingRec === void 0 ? void 0 : boundingRec.y) !== null && _c !== void 0 ? _c : 0);
            var newTooltipData = StackedBarChartUtils_1.getStackedBarTooltipData(subGroups, aggregateTypes, group);
            var xValMarkerText = group.group !== undefined
                ? BarChartUtils_1.formatTooltipXAxisValue(xAxisType, group.group)
                : '';
            ChartTooltip_1.moveTooltip({
                chartContainerType: chartContainerType,
                chartOverlay: _this.SVGElement,
                tooltip: _this.Tooltip,
                absoluteTargetLocationX: ((_d = xScale(group.group)) !== null && _d !== void 0 ? _d : 0) + xScale.bandwidth(),
                absoluteTargetLocationY: absoluteMouseYLocation,
                tooltipXOffset: tooltipXOffset,
                tooltipYOffset: tooltipYOffset,
                flipWidth: xScale.bandwidth(),
            });
            ChartTooltip_1.moveTooltipXAxisMarker({
                tooltipXAxisMarker: _this.TooltipXAxisMarker,
                tooltipXAxisMarkerText: _this.TooltipXAxisMarkerText,
                xScale: xScale,
                xVal: group.group,
                markerText: xValMarkerText,
                xLocationOffset: xScale.bandwidth() / 2,
            });
            _this.setState({ hoveredGroup: groupNumber, tooltipData: newTooltipData });
        };
        _this.onMouseLeaveBars = function () {
            ChartTooltip_1.hideTooltipComponents({
                tooltip: _this.Tooltip,
                tooltipXAxisMarker: _this.TooltipXAxisMarker,
                tooltipXAxisMarkerText: _this.TooltipXAxisMarkerText,
                useTransition: true,
            });
            _this.setState({ hoveredGroup: null });
        };
        _this.onMouseEnterBars = function () {
            ChartTooltip_1.showTooltipComponents({
                tooltip: _this.Tooltip,
                tooltipXAxisMarker: _this.TooltipXAxisMarker,
                tooltipXAxisMarkerText: _this.TooltipXAxisMarkerText,
            });
        };
        _this.createAttributes = _this.createAttributes.bind(_this);
        _this.onChartResize = _this.onChartResize.bind(_this);
        _this.onDragScroll = _this.onDragScroll.bind(_this);
        _this.onDragScrollEnd = _this.onDragScrollEnd.bind(_this);
        _this.onMouseOverBars = _this.onMouseOverBars.bind(_this);
        _this.onMouseLeaveBars = _this.onMouseLeaveBars.bind(_this);
        _this.onMouseEnterBars = _this.onMouseEnterBars.bind(_this);
        _this.SVGElement = null;
        _this.BarChart = null;
        _this.Tooltip = null;
        _this.TooltipXAxisMarker = null;
        _this.TooltipXAxisMarkerText = null;
        _this.chartMargin = {
            left: 0,
            right: 100,
            top: 0,
            bottom: 55,
        };
        _this.chartBreakPoints = {
            small: [570, 200],
            medium: [770, 400],
        };
        _this.minPixelsPerGroup = 18;
        _this.state = {
            chartWidth: 0,
            chartHeight: 0,
            xScaleGroup: chartUtils_1.getScaleByType('BAND', [], [0, 0], 0.4),
            chartZoomFactor: 1,
            zoomState: null,
            scrollCursor: 'auto',
            hoveredGroup: null,
            tooltipData: [],
            isLoading: true,
        };
        return _this;
    }
    StackedBarChart.prototype.componentDidMount = function () {
        this.createAttributes();
    };
    StackedBarChart.prototype.componentDidUpdate = function (prevProps) {
        var _a = this.state, chartWidth = _a.chartWidth, chartHeight = _a.chartHeight;
        if (!isEqual_1.default(prevProps, this.props)) {
            this.onChartResize(chartWidth, chartHeight, true);
        }
    };
    StackedBarChart.prototype.onChartResize = function (newWidth, newHeight, componentUpdated) {
        var data = this.props.data;
        var _a = this.state, chartWidth = _a.chartWidth, chartHeight = _a.chartHeight;
        var minPixelsPerGroup = this.minPixelsPerGroup;
        var newWidthWithMargin = chartUtils_1.getChartWidthWithMargin(newWidth, this.chartMargin);
        var newHeightWithMargin = chartUtils_1.getChartHeightWithMargin(newHeight, this.chartMargin);
        var xAxisDomain = BarChartUtils_1.getUniqueGroups(data);
        var newXScaleGroup = chartUtils_1.getScaleByType('BAND', xAxisDomain, [0, newWidthWithMargin], 0.4);
        var newChartZoomFactor = 1;
        var newScrollCursor = 'auto';
        var pixelsPerGroup = newXScaleGroup.bandwidth();
        if (pixelsPerGroup < minPixelsPerGroup) {
            newChartZoomFactor = minPixelsPerGroup / pixelsPerGroup;
            newXScaleGroup.range([0, newWidthWithMargin * newChartZoomFactor]);
            newScrollCursor = 'grab';
        }
        if (!isEqual_1.default(newWidthWithMargin, chartWidth) ||
            !isEqual_1.default(newHeightWithMargin, chartHeight) ||
            componentUpdated) {
            this.setState({
                xScaleGroup: newXScaleGroup,
                chartWidth: newWidthWithMargin,
                chartHeight: newHeightWithMargin,
                chartZoomFactor: newChartZoomFactor,
                scrollCursor: newScrollCursor,
                isLoading: false,
            });
            this.createAttributes();
        }
    };
    StackedBarChart.prototype.onDragScroll = function () {
        var _a;
        var _b = this.state, xScaleGroup = _b.xScaleGroup, chartZoomFactor = _b.chartZoomFactor, chartWidth = _b.chartWidth;
        var newZoomState = chartUtils_1.getNewZoomState(this.SVGElement);
        var newXScaleGroup = xScaleGroup.copy();
        newXScaleGroup.range([0, chartZoomFactor * chartWidth].map(function (d) { return newZoomState.applyX(d); }));
        var newScrollCursor = chartUtils_1.getNewZoomCursor((_a = d3.event.sourceEvent) === null || _a === void 0 ? void 0 : _a.type);
        this.setState({
            xScaleGroup: newXScaleGroup,
            zoomState: newZoomState,
            scrollCursor: newScrollCursor,
        });
    };
    StackedBarChart.prototype.createAttributes = function () {
        var chartMargin = this.chartMargin;
        d3.select(this.BarChart).attr('transform', chartUtils_1.getChartTransformation(chartMargin));
    };
    StackedBarChart.prototype.render = function () {
        var _this = this;
        var _a = this.props, data = _a.data, colorScale = _a.colorScale, yAxis = _a.yAxis, xAxis = _a.xAxis, chartContainerBreakpoints = _a.chartContainerBreakpoints, isPercentage = _a.isPercentage;
        var _b = this.state, chartHeight = _b.chartHeight, chartWidth = _b.chartWidth, xScaleGroup = _b.xScaleGroup, chartZoomFactor = _b.chartZoomFactor, zoomState = _b.zoomState, scrollCursor = _b.scrollCursor, hoveredGroup = _b.hoveredGroup, tooltipData = _b.tooltipData, isLoading = _b.isLoading;
        var _c = this, chartMargin = _c.chartMargin, chartBreakPoints = _c.chartBreakPoints;
        var stackedData = StackedBarChartUtils_1.getStackedData(data);
        var axisLabelPadding = chartHeight <= chartBreakPoints.small[1] ? 12 : 16;
        var minY = d3.min(stackedData, function (stack) { return d3.min(stack, function (val) { return val.y0; }); });
        var maxY = d3.max(stackedData, function (stack) { return d3.max(stack, function (val) { return val.y1; }); });
        minY = minY !== null && minY !== void 0 ? minY : 0;
        maxY = maxY !== null && maxY !== void 0 ? maxY : 0;
        var yAxisDomain = [minY, maxY];
        var yAxisRange = isPercentage
            ? [chartHeight, axisLabelPadding]
            : [chartHeight - axisLabelPadding, axisLabelPadding];
        var yScale = chartUtils_1.getScaleByType(yAxis.type, yAxisDomain, yAxisRange);
        var xAxisDomain = BarChartUtils_1.getUniqueGroups(data);
        var xAxisTickFormat = BarChartUtils_1.getXAxisTickFormat(xAxis.type, chartWidth, chartBreakPoints, xAxisDomain);
        var secondaryXAxisTickFormat = BarChartUtils_1.getSecondaryXAxisTickFormat(xAxis.type, chartWidth, chartBreakPoints, xAxisDomain);
        var secondaryXAxisHeightOffset = 16;
        var yAxisTickValues;
        var yAxisTickNumber = chartHeight <= chartBreakPoints.medium[1] ? 4 : 6;
        if (chartHeight <= chartBreakPoints.small[1]) {
            if (minY < 0 && maxY > 0) {
                yAxisTickValues = [minY, 0, maxY];
            }
            else {
                yAxisTickValues = [minY, maxY];
            }
        }
        if (isPercentage) {
            yAxisTickValues = [20, 40, 60, 80, 100];
        }
        var extent = [
            [0, 0],
            [chartWidth * chartZoomFactor + chartMargin.right, chartHeight],
        ];
        var scrollBehavior = d3
            .zoom()
            .scaleExtent([1, 1])
            .translateExtent(extent)
            .on('zoom', this.onDragScroll)
            .on('end', this.onDragScrollEnd);
        scrollBehavior(d3.select(this.SVGElement));
        var showScrollButtons = chartZoomFactor > 1;
        var rightDisableThreshold = 20;
        var chartScrollIncrease = chartWidth - xScaleGroup.bandwidth();
        var disableLeftScrollButton = !zoomState || zoomState.x === 0;
        var disableRightScrollButton = chartZoomFactor * chartWidth +
            ((zoomState === null || zoomState === void 0 ? void 0 : zoomState.x) || 0) -
            rightDisableThreshold <=
            chartWidth;
        var chartClipID = uniqueId_1.default('clip-path');
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(ChartContainer_1.ChartContainer, { onChartResize: this.onChartResize, tagsLegendColorScale: colorScale, tagsLegendData: data.aggregateTypes, breakpoints: chartContainerBreakpoints },
                react_1.default.createElement("svg", { width: chartUtils_1.getSVGWidth(chartWidth, chartMargin), height: chartUtils_1.getSVGHeight(chartHeight, chartMargin), ref: function (el) { return (_this.SVGElement = el); }, cursor: chartZoomFactor > 1 ? scrollCursor : 'auto', onMouseLeave: this.onMouseLeaveBars },
                    react_1.default.createElement("g", { ref: function (el) { return (_this.BarChart = el); }, width: chartWidth, height: chartHeight }, !isLoading && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("g", { clipPath: "url(#" + chartClipID + ")" }, data.groupedData.map(function (g, groupNumber) {
                            var _a;
                            return (react_1.default.createElement("g", { transform: "translate(" + ((_a = xScaleGroup(g.group) -
                                    (xScaleGroup.step() - xScaleGroup.bandwidth()) /
                                        2) !== null && _a !== void 0 ? _a : 0) + ", 0)", key: g.group + "-group", onMouseMove: function (event) {
                                    return _this.onMouseOverBars({
                                        group: g,
                                        groupNumber: groupNumber,
                                        event: event,
                                        xScale: xScaleGroup,
                                        xAxisType: xAxis.type,
                                    });
                                }, onMouseEnter: _this.onMouseEnterBars },
                                react_1.default.createElement("rect", { height: chartHeight, y: 0, x: 0, width: xScaleGroup.step(), fill: hoveredGroup === groupNumber
                                        ? '#eaeaea'
                                        : 'transparent' }),
                                xAxis.gridLines === 'ALL' && (react_1.default.createElement(BarChartVerticalGridLine_1.BarChartVerticalGridLine, { groupNumber: groupNumber, xScaleGroup: xScaleGroup, chartHeight: chartHeight, group: g })),
                                react_1.default.createElement(StackedBar_1.StackedBar, { stackedData: stackedData[groupNumber], colorScale: colorScale, xScaleGroup: xScaleGroup, yScale: yScale })));
                        })),
                        react_1.default.createElement(Axis_1.Axis, { mixBlendMode: "multiply", width: chartWidth, height: chartHeight - chartMargin.top, orientation: "RIGHT", scale: yScale, displayLine: false, ticks: yAxisTickNumber, tickValues: yAxisTickValues, tickFormat: BarChartUtils_1.yAxisTickFormat, gridLines: "ALL", label: yAxis.label, unit: yAxis.unit, axisLabelPadding: axisLabelPadding, type: yAxis.type, maxAxisLabelWidth: chartHeight - axisLabelPadding }),
                        react_1.default.createElement(Axis_1.Axis, { width: chartWidth, height: chartHeight, orientation: "BOTTOM", scale: xScaleGroup, tickFormat: xAxisTickFormat, axisExtension: this.chartMargin.right, tickLabelAnchor: "center", type: xAxis.type, "data-test-component-name": "line-chart-x-axis-primary" }),
                        secondaryXAxisTickFormat && (react_1.default.createElement(Axis_1.Axis, { width: chartWidth, height: chartHeight + secondaryXAxisHeightOffset, orientation: "BOTTOM", scale: xScaleGroup, tickFormat: secondaryXAxisTickFormat, displayLine: false, axisExtension: this.chartMargin.right, tickLabelAnchor: "center", type: xAxis.type, "data-test-component-name": "line-chart-x-axis-secondary" })),
                        react_1.default.createElement("clipPath", { id: chartClipID },
                            react_1.default.createElement("rect", { x: 0, y: 0, width: chartWidth, height: chartHeight }))))),
                    react_1.default.createElement(ChartTooltip_1.ChartTooltipXAxisMarker, { ref: function (el) { return (_this.TooltipXAxisMarker = el); }, chartHeight: chartHeight }),
                    react_1.default.createElement(ChartTooltip_1.ChartTooltipXAxisMarkerText, { ref: function (el) { return (_this.TooltipXAxisMarkerText = el); }, chartHeight: chartHeight }),
                    showScrollButtons && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(ChartScrollCurtain_1.ChartScrollCurtain, { scrollDirection: "left", chartHeight: chartHeight, chartWidth: chartWidth, disabled: disableLeftScrollButton }),
                        react_1.default.createElement(ChartScrollCurtain_1.ChartScrollCurtain, { scrollDirection: "right", chartHeight: chartHeight, chartWidth: chartWidth, disabled: disableRightScrollButton }),
                        react_1.default.createElement(ChartScrollButton_1.ChartScrollButton, { scrollDirection: "left", chartHeight: chartHeight, chartWidth: chartWidth, onScroll: function () {
                                return chartUtils_1.onScrollButtonClick(scrollBehavior, _this.SVGElement, chartScrollIncrease);
                            }, disabled: disableLeftScrollButton }),
                        react_1.default.createElement(ChartScrollButton_1.ChartScrollButton, { scrollDirection: "right", chartHeight: chartHeight, chartWidth: chartWidth, onScroll: function () {
                                return chartUtils_1.onScrollButtonClick(scrollBehavior, _this.SVGElement, -chartScrollIncrease);
                            }, disabled: disableRightScrollButton }))))),
            react_1.default.createElement(ChartTooltip_1.ChartTooltip, { colorScale: colorScale, data: tooltipData, ref: function (el) { return (_this.Tooltip = el); }, type: "STACKED_BAR", colorCodeValues: !isPercentage })));
    };
    return StackedBarChart;
}(react_1.PureComponent));
exports.StackedBarChart = StackedBarChart;
